<template>
    <div id="coll" style="width: 90%">
        <Breadcrumb></Breadcrumb>
        <!--按钮组-->
        <div style="text-align: right;margin-top: 15px">
            <el-button type="info">一键翻译</el-button>
            <el-button type="warning">保存</el-button>
            <el-dropdown trigger="click" @command="batchHandle">
                <el-button type="success" style="margin-left: 10px">发布</el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="1">立即发布</el-dropdown-item>
                    <el-dropdown-item command="2">批量发布</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <!--基本信息-->
        <div style="background-color: white;margin-top: 15px;" id="jbxx">
            <el-container>
                <!-- 头部 -->
                <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>基本信息</strong></el-header>
                <!-- 分割线 -->
                <el-divider margin="8px,0"></el-divider>
                <el-main style="padding-left: 100px">
                    <el-form ref="jbxxForm" :model="jbxxForm" label-width="80px" :rules="rules">
                        <el-form-item label="店铺帐号" prop="account">
                            <el-select clearable  v-model="jbxxForm.account" placeholder="---请选择店铺---" style="width: 300px" size="small">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品分类" prop="cpfl">
                            <el-select clearable  v-model="jbxxForm.cpfl" placeholder="请选择" style="width: 300px" size="small">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <el-button type="primary" style="margin-left: 15px" size="small">选择分类</el-button>
                        </el-form-item>
                        <el-form-item label="产品属性">
                            <div style="width: 400px;height: 200px;background-color: #EEEEEE;padding: 15px 25px 25px 60px">
                                <el-form-item label="产品分类" prop="cpfl">
                                    <el-select clearable  v-model="jbxxForm.cpfl" placeholder="请选择" style="width: 300px" size="small">
                                        <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="产品分类" prop="cpfl" style="margin-top: 15px">
                                    <el-select clearable  v-model="jbxxForm.cpfl" placeholder="请选择" style="width: 300px" size="small">
                                        <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="产品分类" prop="cpfl" style="margin-top: 15px">
                                    <el-select clearable  v-model="jbxxForm.cpfl" placeholder="请选择" style="width: 300px" size="small">
                                        <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="产品分类" prop="cpfl" style="margin-top: 15px">
                                    <el-select clearable  v-model="jbxxForm.cpfl" placeholder="请选择" style="width: 300px" size="small">
                                        <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-form-item>
                    </el-form>
                </el-main>
            </el-container>

        </div>
        <!--xx信息-->
        <div style="background-color: white;margin-top: 15px" id="xx">
            <el-container>
                <!-- 头部 -->
                <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>xx信息(注:下列信息,仅在此xxx生效)</strong>
                </el-header>
                <!-- 分割线 -->
                <el-divider margin="8px,0"></el-divider>
                <el-main style="padding-left: 100px">
                    <el-form ref="xxForm" :model="xxForm" label-width="80px">
                        <el-form-item label="XXX分类">
                            <el-select clearable  v-model="xxForm.fl" placeholder="---请选择---" style="width: 300px" size="small">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="来源URL" size="small">
                            <el-row>
                                <el-col :span="1">
                                    <div style="font-size: 20px;background-color: #F7F7F7;text-align: center">1</div>
                                </el-col>
                                <el-input v-model="xxForm.DefaultUrl" placeholder="请输入内容"
                                          style="width: 400px;margin-right: 20px"></el-input>
                                <el-button type="primary">访问</el-button>
                                <el-button icon="el-icon-plus" @click="addURL"></el-button>
                            </el-row>
                            <div v-for="(item, i) in xxForm.url" :key="i">
                                <el-col :span="1">
                                    <div style="font-size: 20px;background-color: #F7F7F7;text-align: center">{{i+2}}
                                    </div>
                                </el-col>
                                <el-input v-model="item.url" placeholder="请输入内容"
                                          style="width: 400px;margin-right: 20px"></el-input>
                                <el-button type="primary">访问</el-button>
                                <el-button icon="el-icon-minus" @click="deletei(i)"></el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </el-main>
            </el-container>
        </div>
        <!--测试-->
        <div  style="position:fixed;bottom: 50%;left: 90%;z-index:999999;">
            <el-row >
                <el-col :span="12" >
                    <div class="block">
                        <el-slider
                                v-model="slider.value1"
                                vertical
                                height="250px" :disabled="true">
                        </el-slider>
                    </div>
                </el-col>
                <el-col :span="12">
                    <el-button id="jbxxbt" type="text"  @click="gd('jbxx',93)">基本信息</el-button><br>
                    <el-button id="xxbt" type="text"  @click="gd('xx',79)">XX信息</el-button><br>
                    <el-button id="cpbt" type="text"  @click="gd('cp',63)">产品信息</el-button><br>
                    <el-button id="picbt" type="text"  @click="gd('pic',47)">图片信息</el-button><br>
                    <el-button id="bzbt" type="text"  @click="gd('bz',30)">变种信息</el-button><br>
                    <el-button id="bzysbt" type="text"  @click="gd('bzys',14)">包装与运输</el-button><br>
                </el-col>
            </el-row>

        </div>


        <!--产品信息-->
        <div style="background-color: white;margin-top: 15px" id="cp">
            <el-container>
                <!-- 头部 -->
                <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>产品信息</strong></el-header>
                <!-- 分割线 -->
                <el-divider margin="8px,0"></el-divider>
                <el-main style="padding-left: 100px">
                    <el-form ref="xxForm" :model="xxForm" label-width="80px">
                        <el-form-item label="类型:">
                            <template>
                                <el-radio v-model="radio" label="1">单品</el-radio>
                                <el-radio v-model="radio" label="2">多品种</el-radio>
                            </template>
                        </el-form-item>
                        <el-form-item label="ParentSKU:">
                            <el-input v-model="xxForm.DefaultUrl" placeholder="请输入内容"
                                      style="width: 400px;margin-right: 20px" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="产品标题:">
                            <el-input type="textarea" show-word-limit maxlength="60" v-model="xxForm.DefaultUrl"
                                      placeholder="请输入内容" style="width: 400px;margin-right: 20px"></el-input>
                        </el-form-item>
                        <el-form-item label="产品描述:">
                            <el-input type="textarea" :rows="8" show-word-limit maxlength="3000"
                                      v-model="xxForm.DefaultUrl" placeholder="请输入内容"
                                      style="width: 400px;margin-right: 20px"></el-input>
                        </el-form-item>
                    </el-form>
                </el-main>
            </el-container>

        </div>
        <!--图片信息-->
        <div style="background-color: white;margin-top: 15px" id="pic">
            <el-container>
                <!-- 头部 -->
                <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>图片信息</strong></el-header>
                <!-- 分割线 -->
                <el-divider margin="8px,0"></el-divider>
                <el-main style="width: 100%">
                    <el-row>
                        <el-col :span="8">
                            <el-upload
                                    class="upload-demo"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :on-preview="handlePreview"
                                    :on-remove="handleRemove"
                                    :before-remove="beforeRemove"
                                    multiple
                                    :limit="3"
                                    :on-exceed="handleExceed"
                                    :file-list="fileList">
                                <span style="margin-right: 15px">产品图片:</span>
                                <el-button size="small" type="primary">点击上传</el-button>
                            </el-upload>
                        </el-col>
                        <el-col :span="16" style="text-align: right">
                            <el-link type="primary">批量加水印</el-link>
                            <span style="margin-left: 15px;margin-right: 15px;color: #029ef3">|</span>
                            <el-link type="primary">改变图片大小</el-link>
                            <span style="margin-left: 15px;margin-right: 15px;color: #029ef3">|</span></span>
                            <el-link type="primary">导出全部图片</el-link>
                        </el-col>
                    </el-row>
                    <el-row style="text-align: center">
                        <span style="color: #8a8a8a;">点击图片拖动,即可调整图片顺序![图片最多选择9张,已经选择了{{count}}张]</span>
                    </el-row>
                    <el-row>
                        <draggable @start="start" @end="end">
                            <el-col :span="2" v-for="(o, index) in picList" :key="index" :offset="1">
                                <el-card :body-style="{ padding: '0px' }">
                                    <el-checkbox :label="index" @change="checked=>change(checked,index)"
                                                 v-model="o.checked">选择
                                    </el-checkbox>
                                    <img :src="o.img"
                                         class="image">
                                    <div style="padding-top: 10px;padding-bottom: 10px">
                                        <el-row>
                                            <el-col :span="15">
                                                <el-button type="text" class="button">在线美图</el-button>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-button type="text" class="button">移除</el-button>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-card>
                            </el-col>
                        </draggable>
                    </el-row>
                    <el-row style="margin-top: 15px">
                        <span style="margin-right: 15px">尺码图片:</span>
                        <span style="margin-right: 15px;color: #8a8a8a">图片大小不能超过500k,像素不能超过2000*2000,图片最多选择一张</span>
                    </el-row>
                    <el-row style="margin-top: 15px" id="upload">
                        <el-upload
                                class="upload-demo"
                                drag
                                action="https://jsonplaceholder.typicode.com/posts/"
                                multiple style="width: 200px">
                            <i class="el-icon-plus" style="font-size: 80px"></i>
                            <div class="el-upload__text"><strong style="font-size: 20px">添加图片</strong></div>
                        </el-upload>
                    </el-row>
                </el-main>
            </el-container>

        </div>
        <!--变种信息-->
        <div style="background-color: white;margin-top: 15px" id="bz">
            <el-container>
                <!-- 头部 -->
                <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>变种信息</strong></el-header>
                <!-- 分割线 -->
                <el-divider margin="8px,0"></el-divider>
                <el-main style="width: 100%">
                    <el-row>
                        <span style="margin-right: 15px">变种主题:</span>
                        <el-checkbox :v-model="bzxx.Color">Color</el-checkbox>
                        <el-checkbox :v-model="bzxx.size">size</el-checkbox>
                        <el-button type="primary" style="margin-left: 15px" size="small">添加自定义属性</el-button>

                    </el-row>
                    <div style="background-color: white;margin-top: 15px;width: 100%">
                        <el-container style="border: 1px solid #DCDFE6;margin-bottom: 15px">
                            <!-- 头部 -->
                            <el-header style="background-color: #F7F7F7;color: #A2A2A2;padding-top: 20px">
                                <el-col :span="5">
                                    <strong>变种主题1:颜色</strong>
                                </el-col>
                                <el-col :span="19" style="text-align: right">
                                    <span><el-link type="primary">移除</el-link></span>
                                </el-col>
                            </el-header>
                            <el-main style="width: 100%">
                                <el-row style="margin-left: 4.16667%;">
                                    <el-checkbox :v-model="bzxx.Color">蓝色</el-checkbox>
                                    <el-checkbox :v-model="bzxx.size">粉色</el-checkbox>
                                </el-row>
                                <el-row style="margin-top: 15px;margin-left: 4.16667%;">
                                    <el-input :v-model="bzxx.input" placeholder="请输入内容" style="width: 300px" size="small"></el-input>
                                    <el-button type="primary" style="margin-left: 15px" size="small">添加</el-button>
                                </el-row>
                                <el-row>
                                    <el-col :span="2" v-for="(o, index) in bzxx.picList" :key="index" :offset="1">
                                        <el-card :body-style="{ padding: '0px' }">
                                            <div style="text-align: center">{{o.color}}</div>
                                            <el-row>
                                                <el-col :span="10">
                                                    <img :src="o.img"
                                                         class="image">
                                                </el-col>
                                                <el-col :span="14" style="text-align: right">
                                                    <i class="el-icon-error"></i>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-col>
                                </el-row>
                            </el-main>
                        </el-container>
                        <!--第二个主题-->
                        <el-container style="border: 1px solid #DCDFE6;margin-bottom: 15px">
                            <!-- 头部 -->
                            <el-header style="background-color: #F7F7F7;color: #A2A2A2;padding-top: 20px">
                                <el-col :span="5">
                                    <strong>变种主题2:适合身高</strong>
                                </el-col>
                                <el-col :span="19" style="text-align: right">
                                    <span><el-link type="primary">移除</el-link></span>
                                </el-col>
                            </el-header>
                            <el-main style="width: 100%">
                                <el-row style="margin-left: 4.16667%;">
                                    <el-checkbox :v-model="bzxx.Color">100cm</el-checkbox>
                                    <el-checkbox :v-model="bzxx.size">110cm</el-checkbox>
                                </el-row>
                                <el-row style="margin-top: 15px;margin-left: 4.16667%;">
                                    <el-input :v-model="bzxx.input" placeholder="请输入内容" style="width: 300px" size="small"></el-input>
                                    <el-button type="primary" style="margin-left: 15px" size="small">添加</el-button>
                                </el-row>
                                <el-row>
                                    <el-col :span="2" v-for="(o, index) in bzxx.picList" :key="index" :offset="1">
                                        <el-card :body-style="{ padding: '0px' }">
                                            <div style="text-align: center">{{o.color}}</div>
                                            <el-row>
                                                <el-col :span="10">
                                                    <img :src="o.img"
                                                         class="image">
                                                </el-col>
                                                <el-col :span="14" style="text-align: right">
                                                    <i class="el-icon-error"></i>
                                                </el-col>
                                            </el-row>
                                        </el-card>
                                    </el-col>
                                </el-row>
                            </el-main>
                        </el-container>
                        <el-row style="color: #8a8a8a">
                            只有选择了折扣活动,填写限购,折扣才会生效,限购为"0",表示不限购
                        </el-row>
                        <!--表格-->
                        <div style="margin-top: 20px">
                            <el-table
                                    :data="bzxx.tableData"
                                    style="width: 100%">
                                <el-table-column
                                        prop="date"
                                        label="颜色"
                                        width="100">
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        label="适合身高"
                                        width="100">
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        align="center"
                                        width="150">
                                    <template slot="header" slot-scope="scope">
                                        <el-row>SKU</el-row>
                                        <el-row style="color: #029ef3">(自动生成)</el-row>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-input
                                                size="mini"
                                                v-model="bzxx.input"
                                                style="width: 100px"/>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        align="center"
                                        width="100">
                                    <template slot="header" slot-scope="scope">
                                        <el-row>价格</el-row>
                                        <el-row style="color: #029ef3">(修改)</el-row>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-input
                                                size="mini"
                                                v-model="bzxx.input"
                                                style="width: 70px"/>
                                    </template>
                                </el-table-column>
                                <el-table-column>
                                    <template slot="header" slot-scope="scope">
                                        <el-row>
                                            <el-col :span="12">
                                                <span>折扣活动</span>
                                                <span style="color: #029ef3">请选择</span>
                                            </el-col>
                                            <el-col :span="12" style="text-align: right">
                                                <span>限购</span>
                                                <el-input
                                                        size="mini"
                                                        v-model="bzxx.input"
                                                        style="width: 100px"/>
                                            </el-col>
                                        </el-row>
                                    </template>
                                    <el-table-column
                                            prop="province"
                                            width="600">
                                        <template slot="header" slot-scope="scope">
                                            <el-row>
                                                <el-col :span="12">
                                                    <div style="text-align: left;margin-left: 60px;">
                                                        <span>促销价</span>
                                                        <span style="color: #029ef3">(批量)</span>
                                                    </div>
                                                </el-col>
                                                <el-col :span="12">
                                                    <div style="text-align: right;margin-right: 60px;">
                                                        <span>折扣</span>
                                                        <span style="color: #029ef3">(批量)</span>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-row>
                                                <el-col :span="3">
                                                    <el-switch
                                                            v-model="bzxx.switchValue"
                                                            active-color="#13ce66"
                                                            inactive-color="#CCCCCC">
                                                    </el-switch>
                                                </el-col>
                                                <el-col :span="7">
                                                    <el-input
                                                            size="mini"
                                                            v-model="bzxx.input"
                                                            style="width: 150px"/>
                                                </el-col>
                                                <el-col :span="4" style="text-align: center">
                                                    <span>或</span>
                                                </el-col>
                                                <el-col :span="10" style="text-align: right">
                                                    <el-input
                                                            size="mini"
                                                            v-model="bzxx.input"
                                                            style="width: 150px"/>
                                                    <span>%OFF(0折)</span>
                                                </el-col>
                                            </el-row>
                                        </template>
                                    </el-table-column>
                                </el-table-column>
                                <el-table-column
                                        prop="name"
                                        align="center">
                                    <template slot="header" slot-scope="scope">
                                        <el-row>库存</el-row>
                                        <el-row style="color: #029ef3">(修改)</el-row>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-input
                                                size="mini"
                                                v-model="bzxx.input"
                                                style="width: 100px"/>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <!--多件优惠-->
                        <div style="margin-top: 15px">
                            <el-row>
                                <el-col :span="2">
                                    <span>多件优惠:</span>
                                </el-col>
                                <el-col :span="22">
                                    <el-table
                                            border
                                            :data="bzxx.tableData2"
                                            style="width: 100%"
                                            :header-cell-style="{background:'#eef1f6',color:'#595a5a'}">
                                        <el-table-column
                                                prop="sort"
                                                label=""
                                                width="180"
                                                align="center">
                                            <template slot-scope="scope">
                                                <span>{{scope.row.sort+(scope.$index+1)}}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="name"
                                                label="购买数量"
                                                align="center">
                                            <template slot-scope="scope">
                                                <el-row>
                                                    <el-col :span="10" style="text-align: right">
                                                        <el-input
                                                                size="mini"
                                                                v-model="scope.row.count1"
                                                                style="width: 150px"/>
                                                    </el-col>
                                                    <el-col :span="4" style="text-align: center">
                                                        <span>---</span>
                                                    </el-col>
                                                    <el-col :span="10" style="text-align: left">
                                                        <el-input
                                                                size="mini"
                                                                v-model="scope.row.count2"
                                                                style="width: 150px"/>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                                prop="address"
                                                label="价格"
                                                align="center"
                                                width="230">
                                            <template slot-scope="scope">
                                                <el-row>
                                                    <el-input
                                                            onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                                                            size="mini"
                                                            v-model="scope.row.price"
                                                            style="width: 150px"/>
                                                    <span>TWD</span>
                                                </el-row>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="handel" label="操作" align="center" width="150">
                                            <template slot-scope="scope">
                                                <el-button type="text" size="mini" @click="deleteRow(scope.$index)">移除
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3" style="text-align: right">
                                    <el-button type="text" size="mini" @click="add">新增区间</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-main>
            </el-container>
        </div>
        <!--包装与运输-->
        <div style="background-color: white;margin-top: 15px" id="bzys">
            <el-container>
                <!-- 头部 -->
                <el-header style="color: #A2A2A2;padding-top: 20px;height: 30px"><strong>包装与运输</strong></el-header>
                <!-- 分割线 -->
                <el-divider margin="8px,0"></el-divider>
                <el-main style="width: 100%">
                    <div>
                        <el-form ref="aa" label-width="80px" :model="bzyys.formLabelAlign">
                            <el-form-item label="重量:">
                                <el-input v-model="bzyys.formLabelAlign.name" style="width: 200px" size="small"></el-input>
                                <el-button type="info" disabled size="small">KG</el-button>
                            </el-form-item>
                            <el-form-item label="尺寸规格:">
                                <el-input v-model="bzyys.formLabelAlign.name" style="width: 200px" size="small"></el-input>
                                <el-button type="info" disabled size="small">CM</el-button>
                                <el-input v-model="bzyys.formLabelAlign.name"
                                          style="width: 200px;margin-left: 20px" size="small"></el-input>
                                <el-button type="info" disabled size="small">CM</el-button>
                                <el-input v-model="bzyys.formLabelAlign.name"
                                          style="width: 200px;margin-left: 20px" size="small"></el-input>
                                <el-button type="info" disabled size="small">CM</el-button>
                            </el-form-item>
                            <el-form-item label="是否预估">
                                <el-radio v-model="radio" label="1">否</el-radio>
                                <el-radio v-model="radio" label="2">是</el-radio>
                            </el-form-item>
                            <el-form-item label="物流设置">
                                <el-row>
                                    <el-col :span="12">
                                        <el-container border style="border: 1px solid #EBEEF5;">
                                            <el-header style="padding: 15px 15px 15px 15px;background-color: #B3C0D1;">
                                                物流方式(勾选开启)<i class="el-icon-refresh" style="margin-left: 20px;font-size: 15px;color: blue"></i>
                                            </el-header>
                                            <el-main style="padding-right: 0px;padding-left: 0px;width: 100%;">
                                                <el-row  v-for="(item, i) in bzyys.wlfsList" :key="i" style="border-bottom:1px solid #EBEEF5;">
                                                    <el-checkbox :label="item.name" style="margin-left: 10px"></el-checkbox>
                                                </el-row>
                                            </el-main>
                                        </el-container>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-container>
                                            <el-header style="padding: 15px 15px 15px 15px;background-color: #B3C0D1;">
                                                运费设置
                                            </el-header>
                                            <el-main style="padding-right: 0px;padding-left: 0px;width: 100%;">
                                                <el-row  v-for="(item, i) in bzyys.wlyfList" :key="i" style="border-bottom:1px solid #EBEEF5;">
                                                    <el-col :span="12" style="margin-left: 10px">
                                                        <span>{{item.name}}</span>
                                                    </el-col>
                                                    <el-col :span="10" style="text-align: right">
                                                        <el-checkbox label="免邮"></el-checkbox>
                                                    </el-col>

                                                </el-row>
                                            </el-main>
                                        </el-container>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-main>
            </el-container>

        </div>
    </div>

</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import ElRow from "element-ui/packages/row/src/row";
    //拖动图片插件
    import draggable from 'vuedraggable';

    export default {
        //注册组件
        components: {
            ElRow,
            draggable,
            Breadcrumb
        },
        name: "CollectionBox",
        data() {
            return {
                jbxxForm: {
                    account: '',
                    cpfl: '',
                },
                xxForm: {
                    fl: '',
                    url: [],
                    DefaultUrl: '',
                },
                //下拉框
                options: [{
                    value: '选项1',
                    label: '黄金糕'
                }, {
                    value: '选项2',
                    label: '双皮奶'
                }, {
                    value: '选项3',
                    label: '蚵仔煎'
                }, {
                    value: '选项4',
                    label: '龙须面'
                }, {
                    value: '选项5',
                    label: '北京烤鸭'
                }],
                rules: {
                    account: [
                        {required: true, message: '请选择店铺名称', trigger: 'blur'},
                    ],
                    cpfl: [
                        {required: true, message: '请选择产品分类', trigger: 'blur'},
                    ],
                },
                // 单选
                radio: '1',
                //产品图片
                fileList: [{
                    name: 'food.jpeg',
                    url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
                }, {
                    name: 'food2.jpeg',
                    url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
                }],
                //用于统计选择的图片数量
                count: 0,
                picList: [
                    {
                        id: '1',
                        img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        checked: false
                    },
                    {
                        id: '2',
                        img: 'https://dss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1141259048,554497535&fm=26&gp=0.jpg',
                        checked: false
                    },
                    {
                        id: '3',
                        img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        checked: false
                    },
                    {
                        id: '4',
                        img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        checked: false
                    },
                    {
                        id: '5',
                        img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        checked: false
                    },
                    {
                        id: '6',
                        img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        checked: false
                    },
                    {
                        id: '7',
                        img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        checked: false
                    },
                    {
                        id: '8',
                        img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        checked: false
                    },
                    {
                        id: '9',
                        img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        checked: false
                    },
                    {
                        id: '10',
                        img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        checked: false
                    },
                    {
                        id: '11',
                        img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                        checked: false
                    }
                ],
                // 保存图片的ID
                picID: [],
                //变种信息属性
                bzxx: {
                    color: '',
                    size: '',
                    input: '',
                    switchValue: '',
                    picList: [
                        {
                            id: '11',
                            img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                            color: '蓝色'
                        },
                        {
                            id: '10',
                            img: 'https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png',
                            color: '粉红色'
                        }
                    ],
                    tableData: [{
                        date: '2016-05-03',
                        name: '王小虎',
                        province: '上海',
                        city: '普陀区',
                        address: '上海市普陀区金沙江路 1518 弄',
                        zip: 200333
                    }, {
                        date: '2016-05-02',
                        name: '王小虎',
                        province: '上海',
                        city: '普陀区',
                        address: '上海市普陀区金沙江路 1518 弄',
                        zip: 200333
                    }, {
                        date: '2016-05-04',
                        name: '王小虎',
                        province: '上海',
                        city: '普陀区',
                        address: '上海市普陀区金沙江路 1518 弄',
                        zip: 200333
                    }, {
                        date: '2016-05-01',
                        name: '王小虎',
                        province: '上海',
                        city: '普陀区',
                        address: '上海市普陀区金沙江路 1518 弄',
                        zip: 200333
                    }, {
                        date: '2016-05-08',
                        name: '王小虎',
                        province: '上海',
                        city: '普陀区',
                        address: '上海市普陀区金沙江路 1518 弄',
                        zip: 200333
                    }, {
                        date: '2016-05-06',
                        name: '王小虎',
                        province: '上海',
                        city: '普陀区',
                        address: '上海市普陀区金沙江路 1518 弄',
                        zip: 200333
                    }, {
                        date: '2016-05-07',
                        name: '王小虎',
                        province: '上海',
                        city: '普陀区',
                        address: '上海市普陀区金沙江路 1518 弄',
                        zip: 200333
                    }],
                    //变种信息第二个表格
                    tableData2: [{
                        sort: '优惠期间',
                        count1: '',
                        count2: '',
                        price: '',
                    }, {
                        sort: '优惠期间',
                        count1: '',
                        count2: '',
                        price: '',
                    }, {
                        sort: '优惠期间',
                        count1: '',
                        count2: '',
                        price: '',
                    }, {
                        sort: '优惠期间',
                        count1: '',
                        count2: '',
                        price: '',
                    }],
                },
                bzyys: {
                    labelPosition: 'right',
                    formLabelAlign: {
                        name: '',
                        region: '',
                        type: ''
                    },
                    tableData: [{
                        date: '2016-05-02',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1518 弄'
                    }, {
                        date: '2016-05-04',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1517 弄'
                    }, {
                        date: '2016-05-01',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1519 弄'
                    }, {
                        date: '2016-05-03',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1516 弄'
                    }],
                    wlszTable: [{
                        date: '2016-05-02',
                        name: '王小虎',
                        address: '上海市普陀区金沙江路 1518 弄'
                    }],
                    //物流方式
                    wlfsList: [
                        {
                            name:'虾皮店配-全家',
                        },
                        {
                            name:'虾皮店配-莱尔富(超值)',
                        },
                        {
                            name:'虾皮宅配',
                        },
                        {
                            name:'虾皮店配-711',
                        }

                    ],
                    //运费
                    wlyfList: [
                        {
                            name:'运费:依据重量自动计算',
                        },
                        {
                            name:'运费:依据重量自动计算',
                        },
                        {
                            name:'运费:依据重量自动计算',
                        },
                        {
                            name:'运费:依据重量自动计算',
                        }

                    ],


                },
                //滑块导航的值
                slider:{
                    value1:0,
                }
            }
        },
        created() {

        },
        methods: {
            addURL() {
                this.xxForm.url.push({
                    url: ''
                });
            },
            deletei(index) {
                //获取每个输入框的值
                // alert(this.ddhtableData[0].dt[index].ddh)
                this.xxForm.url.splice(index, 1)
            },
            // 产品图片
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            change(e, index) {
                let defaultValue = event.currentTarget.defaultValue;
                if (e == true && this.count >= 9) {
                    alert("只能选择9张");
                    //取消选中
                    this.picList[index].checked = false;
                    //因为已经点击了checkbox,它的checked=true,所以需要修改为false,不然会进入到false的判断,导致统计数量不准确
                    event.currentTarget.checked = false
                    return
                }
                if (e == false) {
                    //统计选择的图片数量
                    this.count--;
                    //取消选中
                    this.picList[index].checked = false;
                    //如果取消选中,则需要从数组删除指定的ID
                    this.picID.splice(this.picID.indexOf(defaultValue), 1);
                }
                if (e == true) {
                    //统计选择的图片数量
                    this.count++;
                    //把选择的ID保存起来
                    this.picID.push(defaultValue);
                    //设置为选中
                    this.picList[index].checked = true;
                }
            },
            start(e) {
                // alert(e)
            },
            end(e) {
                // alert(e)
            },
            //变种信息添加内容
            add() {
                this.bzxx.tableData2.push(
                    {
                        sort: '优惠期间',
                        count1: '',
                        count2: '',
                        price: '',
                    }
                )
            },
            deleteRow(index) {
                this.bzxx.tableData2.splice(index, 1);
            },
            gd(domId,value){
                //导航的按钮数组
                var colorList=['jbxxbt','xxbt','cpbt','picbt','bzbt','bzysbt'];
                //被点击的按钮移除出来
                if (colorList.indexOf(domId+'bt') > -1){
                    colorList.splice(colorList.indexOf(domId+'bt'),1);
                }
                //没有被点击的导航按钮全部变为蓝色
                for (let key in colorList) {
                    document.getElementById(colorList[key]).style.color='#4934b2';
                }
                //被点击的变红色
                event.currentTarget.style.color='red'
                //设置滑块的值
                this.slider.value1=value
                // 当前窗口正中心位置到指定dom位置的距离

                //页面滚动了的距离
                let height = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                //指定dom到页面顶端的距离
                let dom = document.getElementById(domId);
                let domHeight = dom.offsetTop;

                //滚动距离计算
                var S = Number(height) - Number(domHeight);

                //判断上滚还是下滚
                if(S<0){
                    //下滚
                    S = Math.abs(S);
                    window.scrollBy({ top: S, behavior: "smooth" });
                }else if(S==0){
                    //不滚
                    window.scrollBy({ top: 0, behavior: "smooth" });
                }else{
                    //上滚
                    S = -S
                    window.scrollBy({ top: S, behavior: "smooth" });
                }

            },
            // menu(){
            //     let bb = document.documentElement.scrollTop || document.body.scrollTop;
            //     let height = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            //     let dom1 = document.getElementById('jbxx').offsetTop;
            //     let dom2 = document.getElementById('xx').offsetTop;
            //     let dom3 = document.getElementById('cp').offsetTop;
            //     let dom4 = document.getElementById('pic').offsetTop;
            //     let dom5 = document.getElementById('bz').offsetTop;
            //     let dom6 = document.getElementById('bzys').offsetTop;
            // },


        },
        mounted() {
            // window.addEventListener('scroll', this.menu)
        },
    }
</script>

<style scoped>

    .time {
        font-size: 13px;
        color: #999;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .image {
        width: 97px;
        height: 98px;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    #upload .el-upload-dragger {
        width: 136px;
        height: 106px;
    }

    #wlsz .el-table--border td {
        border-right: 0px solid #EBEEF5;
    }
</style>
<style scoped>
    .td_style {
        border-right: none;
        border-bottom: none;
    }
</style>

